import useDataFromRef from "./useDataFromRef";

export { useDataFromRef };
